import React from 'react'
import { Row, Col, Container } from 'react-bootstrap'
import { StaticQuery, graphql } from 'gatsby'
import styled from 'styled-components'
import { Link } from 'gatsby'

class CloudHosting extends React.Component {

    shouldComponentUpdate() {
        return false
    }

    render() {

        const Section = styled.section`
            position: relative;
            overflow: hidden;
            background-color: #111;
            padding: 240px 0 10px 0;
            .heading {
                width: 100%;
            }
            @media (max-width: 767px) {
                padding: 1100px 0 10px 0;           
            }
        `

        const ServiceRow = styled(Row)`
            margin-top: 10px;
        `

        const ServiceHeading = styled.h3`
            font-size: 28px;
            font-weight: 500;
            font-family: Teko;
            color: #fff;
            margin-bottom: 0px;
            margin-top: 50px;
        `

        const ServiceHeadinga = styled(Link)`
            font-family: Oswald;
            color: #fff;
            transition: .5s;
            &:hover {
              color: #c1eb18;
              text-decoration: none;
            }
        `

        const ServiceSeparator = styled.div`
            height: 2px;
            width: 50px;
            background-color: #c1eb18;
            margin-bottom: 5px;
         `

        const ServiceNumber = styled.p`
            position: absolute;
            font-size: 60px;
            color: #fff;
            font-weight: 900;
            top: -80px;
            opacity: .1;            
            transition: .2s;
         `

        const ServiceElement = styled.div`
            margin-bottom: 90px;
            border-radius: 20px;
            transition: .2s;
            position: relative;
            &:hover ${ServiceNumber} {
                opacity: .3 !important;
                color: #c1eb18;
            }
        `

        const ServiceText = styled.p`
            font-size: 16px;
            font-weight: 300;
            color: #c5c5c5;
            padding-right: 25px;            
         `

        const ServicePrecio = styled.p`
            font-size: 30px;
            font-weight: 300;
            color: #A3FF00;
            padding-right: 25px;
            @media (min-width:768px) and (max-width:1024px) {
                font-size: 20px;            
         `

        const ServiceDesde = styled.sup`
            position: relative;            
            vertical-align: baseline;
            top: -.3em;            
            font-family: 'Poppins';
            line-height: 26px;
            font-size: 14px;
            color: #fff;
            font-style: italic;
            font-weight: lighter;
         `

        const Text = styled.p`
            font-size: 20px;
            font-weight: 300;
            color: #fff;
            padding-bottom: 30px;
            text-align: left;
            line-height: 30px;          
        `

        const Heading2 = styled.h2`
            transform: translate(0px, -100px);
            transition: 1s;
            margin-top: 150px;
            font-size: 95px;
            line-height: 110px;
            font-family: Teko;
            font-weight: 500;
            color: rgb(255, 255, 255);
            text-align: center;
            text-transform: uppercase;          
        `
        const ColorV = styled.span`            
            color: #c1eb18;
            font-family: Teko;                        
        `
        const TextaSpan = styled(Link)`        
            color: #78c91c;
            font-size: 50px;            
            line-height: 60px;
            transition: .5s;
            font-weight: bold;
            text-align: center;
            font-family: roboto,sans-serif;
            padding-bottom: 200px;
                &:hover {
                    color: #fff;
                    text-decoration: none;
                    }
                @media (max-width: 767px) {
                    font-size: 40px;
                    line-height: 50px;                        
                    } 
        `


        const { data } = this.props;
        // Agregar verificación para asegurarse de que los datos están disponibles
        if (!data || !data.allPricesJson || !data.allPricesJson.nodes.length) {
            return <div>Loading...</div>;
        }

        const prices = data.allPricesJson.nodes[0].items;

        console.log(prices)

        return (
            <Section>
                <Container>
                    <Row>
                        <Heading2>Hosting Colombia con <ColorV>SSL Gratis</ColorV></Heading2>
                        <Text>
                            Hosting en Colombia con SSL gratis, VPS, desarrollo de software, SEO y ciberseguridad para pymes en Pereira, Bogotá, Cali. Nuestros servicios
                            integrales incluyen planes de hosting con cPanel, certificados SSL gratuitos, VPS administrados, y diseño web optimizado. Con más de 14 años
                            de experiencia, ofrecemos soluciones a medida para mejorar la presencia online de tu empresa. Desde hosting multidominios hasta diseño de
                            tiendas virtuales en Pereira, te ayudamos a crecer. ¡Cotiza hoy y descubre cómo podemos impulsar tu negocio!
                        </Text>
                        <TextaSpan to="/hosting-colombia"
                            onClick={() => {
                                window.gtag('event', 'click_button_cotiza', {
                                    button_name: 'Cotiza Ahora Hosting',
                                    destination_url: '/hosting-colombia'
                                });
                            }}>Cotiza Ahora
                        </TextaSpan>
                    </Row>
                    <Row>
                        <Heading2>Hosting, <ColorV>Cloud,</ColorV> VPS <ColorV>y</ColorV> Bare <ColorV>Metal</ColorV></Heading2>
                        <Text>
                            Nuestros planes de hosting en Colombia incluyen SSL gratis para proteger tu web y mejorar tu SEO. Ofrecemos Hosting CloudLinux, cPanel, VPS administrados
                            y servidores dedicados con discos SSD, ideales para pymes en Pereira, Bogotá, Cali. ¡Desde ${prices.find(x => x.name === 'Hosting').price}/año!
                        </Text>
                    </Row>
                    <ServiceRow>
                        <Col md={3}>

                            <ServiceElement>
                                <ServiceNumber>
                                    01
                                </ServiceNumber>
                                <ServiceHeading>
                                    <ServiceHeadinga to="hosting-colombia">
                                        Hosting CloudLinux
                                    </ServiceHeadinga>
                                </ServiceHeading>
                                <ServiceSeparator />
                                <ServiceText>
                                    DirectAdmin y cPanel<br></br>Dominio GRATIS<br></br>SO CloudLinux
                                </ServiceText>
                                <ServiceDesde>
                                    Desde
                                </ServiceDesde>
                                <ServicePrecio>
                                    ${prices.find(x => x.name === 'Hosting').price}/año
                                </ServicePrecio>
                            </ServiceElement>

                        </Col>
                        <Col md={3}>

                            <ServiceElement>
                                <ServiceNumber>
                                    02
                                </ServiceNumber>
                                <ServiceHeading>
                                    <ServiceHeadinga to="hosting-cpanel">
                                        Hosting cPanel
                                    </ServiceHeadinga>
                                </ServiceHeading>
                                <ServiceSeparator />
                                <ServiceText>
                                    cPanel<br></br>Dominio GRATIS<br></br>SO CloudLinux
                                </ServiceText>
                                <ServiceDesde>
                                    Desde
                                </ServiceDesde>
                                <ServicePrecio>
                                    ${prices.find(x => x.name === 'cPanel').price}/año
                                </ServicePrecio>
                            </ServiceElement>

                        </Col>
                        <Col md={3}>

                            <ServiceElement>
                                <ServiceNumber>
                                    03
                                </ServiceNumber>
                                <ServiceHeading>
                                    <ServiceHeadinga to="vps">
                                        VPS en RAID 10
                                    </ServiceHeadinga>
                                </ServiceHeading>
                                <ServiceSeparator />
                                <ServiceText>
                                    AlmaLinux 8 o Ubuntu 22<br></br>Discos SSD<br></br>SIN Administrar
                                </ServiceText>
                                <ServiceDesde>
                                    Desde
                                </ServiceDesde>
                                <ServicePrecio>
                                    ${prices.find(x => x.name === 'VPS').price}/mes
                                </ServicePrecio>
                            </ServiceElement>

                        </Col>
                        <Col md={3}>

                            <ServiceElement>
                                <ServiceNumber>
                                    04
                                </ServiceNumber>
                                <ServiceHeading>
                                    <ServiceHeadinga to="servidores-dedicados">
                                        Servidores Dedicados
                                    </ServiceHeadinga>
                                </ServiceHeading>
                                <ServiceSeparator />
                                <ServiceText>
                                    Linux y Windows<br></br>Discos SSD y HDD<br></br>Bare Metal SIN Administrar
                                </ServiceText>
                                <ServiceDesde>
                                    Desde
                                </ServiceDesde>
                                <ServicePrecio>
                                    ${prices.find(x => x.name === 'Dedicados').price}/mes
                                </ServicePrecio>
                            </ServiceElement>

                        </Col>
                    </ServiceRow>
                </Container>
            </Section>
        )
    }

}

export const query = graphql`
  query {
    allPricesJson(filter: { page: { eq: "inicio" }, section: { eq: "planes" } }) {
      nodes {
        items {
          name
          price
        }
      }
    }    
  }
`

const Iconos = (props) => (
    <StaticQuery
        query={query}
        render={(data) => (
            <CloudHosting
                data={data}
            />
        )}
    />
)

export default Iconos;